<template>
  <sidebar
    :addTitle="$t('CashFlow.Project.AddNew')"
    :editTitle="$t('CashFlow.Project.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('CashFlow.Project.Name')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('CashFlow.Project.Name')"
                v-model="projectName"
              ></validated-input>
               <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('CashFlow.Project.RegionName')}}</form-label>
            <ValidationProvider :name="$t('CashFlow.Project.RegionName')" rules="required" v-slot="{ errors }">
            <v-select
                label="name"
                :options="regions"
                v-model="projectRegionId"
                :reduce="region => region.id"
                class="w-full"
            />
            <validation-message
            >{{ errors[0] }}</validation-message>
            </ValidationProvider>
        </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import vSelect from 'vue-select';
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../../shared/components";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    Sidebar,
    vSelect
  },
  data() {
    return {
      projectId: 0,
      projectName: "",
      projectRegionId: 0
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    regions() {
      return this.$store.state.cashflow.regions;
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const {id, name, regionId} = JSON.parse(JSON.stringify(this.data));
      this.projectId = id;
      this.projectName = name;
      this.projectRegionId = regionId;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.projectId = 0;
      this.projectName = "";
      this.projectRegionId = 0;
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.projectId,
            name: this.projectName,
            regionId: this.projectRegionId
          };

          this.$vs.loading();
          
          if (this.projectId !== null && this.projectId > 0) {
            this.$store.dispatch("cashflow/updateProject", obj).then(() => {
              this.$emit("onProjectUpdated", obj);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("cashflow/addProject", obj).then(() => {
              this.$emit("onProjectInserted", obj);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
